__turbopack_context__.v({
  "wrapper": "promotional-progress-bar-element-module-scss-module__fPWEOa__wrapper",
});
